import { API_BASE_URL } from '../../config/constants';
import { AuthTokens, GoogleAuthConfig } from './auth.types';
import { getAuthErrorMessage } from './get-auth-error-message';

export const getGoogleAuthConfig = async (): Promise<GoogleAuthConfig> => {
  const response = await fetch(`${API_BASE_URL}/v1/auth/google/config`);
  if (!response.ok) {
    throw new Error('Failed to load Google auth config');
  }

  return response.json();
};

export const loginWithGoogle = async (code: string): Promise<AuthTokens> => {
  const response = await fetch(`${API_BASE_URL}/v1/auth/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ code }),
  });

  if (!response.ok) {
    throw new Error(await getAuthErrorMessage(response, 'Google sign-in failed'));
  }

  return response.json();
};
